var _linearGradient, _clipPath, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhpmyadmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99,
    height: 20,
    role: "img",
    "aria-label": "phpMyAdmin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phpMyAdmin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 99,
    height: 20,
    fill: "#6c78af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmZmZmIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+cGhwTXlBZG1pbjwvdGl0bGU+PHBhdGggZD0iTTUuNDYzIDMuNDc2QzYuNjkgNS4yMjUgNy40OTcgNy4zOTkgNy42OCA5Ljc5OGExMi45IDEyLjkgMCAwIDEtLjY3MiA1LjI1NCA0LjI5IDQuMjkgMCAwIDEgMi45NjktMS41MjNjLjA1LS4wMDQuMDk5LS4wMDYuMTQ4LS4wMDguMDgtLjQ5MS40Ny0zLjQ1LS45NzctNi42OC0xLjA2OC0yLjM4Ni0zLTMuMTYtMy42ODUtMy4zNjVabTEuNzc3LjAzN3MyLjQwNiAxLjA2NiAzLjMyNiA1LjU0N2MuNjA3IDIuOTU1LjA0OSA0LjgzNi0uNDAyIDUuNzczYTcuMzQ3IDcuMzQ3IDAgMCAxIDQuNTA2LTEuOTk0Yy44Ni0uMDY1IDEuNjk1LjAyIDIuNDgyLjIzMy0uMS0uNzQxLS41OTMtMy40MTQtMi43MzItNS45Mi0zLjI2My0zLjgyMy03LjE4LTMuNjQtNy4xOC0zLjY0Wm0xNC44MTcgOS43MDEtMTcuOTIgMy4wNDlhMi4yODQgMi4yODQgMCAwIDEgMS41MzUgMi4yNTQgMi4zMSAyLjMxIDAgMCAxLS4xMDYuNjFjLjA1NS0uMDI3IDIuNjg5LTEuMjc1IDYuMzQyLTIuMDM0IDMuMjM4LS42NzMgNS43MjMtLjM2IDYuMjg1LS4yNzNhNi40NiA2LjQ2IDAgMCAxIDMuODY0LTMuNjA2em0tNi4yMTMgNC4wNzhjLTIuMzE4IDAtNC42NDEuNDk1LTYuNjE0IDEuMTY2LTIuODY4Ljk3Ni0yLjk1MSAxLjM0OC01LjU1IDEuMDQzQzEuODQ0IDE5LjI4NiAwIDE4LjM4NiAwIDE4LjM4NnMyLjQwNiAxLjk3IDQuOTE0IDIuMTI3YzEuOTg2LjEyNSAzLjUwNS0uODIyIDUuMzE1LTEuNDE0IDIuNjYxLS44NzEgNC41MTEtLjk3IDYuMjUzLS45NzVDMTkuMzYxIDE4LjExNiAyNCAxOS4zNTMgMjQgMTkuMzUzcy0yLjExLTEuMDQ0LTUuMDMzLTEuNzJhMTMuODg1IDEzLjg4NSAwIDAgMC0zLjEyMy0uMzRaIi8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 585,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 710
  }, "phpMyAdmin"), /*#__PURE__*/React.createElement("text", {
    x: 585,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 710
  }, "phpMyAdmin"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhpmyadmin);
export default __webpack_public_path__ + "static/media/phpmyadmin.e85007f6162b8cda26a5466b4ba0aff7.svg";
export { ForwardRef as ReactComponent };